module.exports = __webpack_public_path__ + "img/yellow-color.05ab48b0.svg";